import { useEffect, useState } from 'react';
import { RewardsService } from '../../../services/rewards/RewardsService';

let cachedAmount: number | null = null;
let fetchPromise: Promise<void> | null = null;
let fetchFailed = false;

function fetchIncentive(): Promise<void> {
  if (fetchPromise && !fetchFailed) return fetchPromise;
  fetchFailed = false;
  fetchPromise = new RewardsService()
    .getRebootIncentive()
    .then((res) => { cachedAmount = res?.amount ?? null; })
    .catch(() => {
      cachedAmount = null;
      fetchFailed = true;
      fetchPromise = null;
    });
  return fetchPromise;
}

export function useRebootIncentive(): string {
  const [label, setLabel] = useState(() =>
    cachedAmount != null ? `Restart now · +${cachedAmount} tokens` : 'Restart now',
  );

  useEffect(() => {
    if (cachedAmount != null) {
      setLabel(`Restart now · +${cachedAmount} tokens`);
      return;
    }
    fetchIncentive().then(() => {
      setLabel(cachedAmount != null ? `Restart now · +${cachedAmount} tokens` : 'Restart now');
    });
  }, []);

  return label;
}
